'use strict';

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const waitUntil=require('../../../dist-es6/testUtils/waitUntil');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const ScrollDurationMs=262;let

SidebarScrollingService=class SidebarScrollingService{
constructor($document,$timeout){
this._$document=$document;
this._$timeout=$timeout;
this._preventAutoScroll=!1;

this.reset();
}

get _scrollerWrapper(){
return this.__scrollerWrapperElement||(
this.__scrollerWrapperElement=angular.element(this._$document).find('#sidebar.pulsar-scrollbar'));
}

reset(){
if(_.exists(this.__scrollerWrapperElement)){
this.__scrollerWrapperElement.stop(!0,!0);
}
this.__scrollerWrapperElement=void 0;
this._isScrolling=!1;
this._lastItem=void 0;
}

immediatelyJumpToLastPosition(){
if(!_.exists(this._lastPosition)){
return;
}
waitUntil(()=>this._preventAutoScroll===!1).
then(()=>{
this._preventAutoScroll=!0;
fastdom.mutate(()=>{
this._scrollerWrapper.stop(!0,!1);
this._scrollerWrapper.scrollTop(this._lastPosition);
this._$timeout(()=>{
this._preventAutoScroll=!1;
},50);
});
});
}

get preventAutoScroll(){
return this._preventAutoScroll;
}

set preventAutoScroll(preventAutoScroll){
this._preventAutoScroll=preventAutoScroll;
}

updateLastPosition(newScrollTop){
this._lastPosition=newScrollTop;
}

async scrollToSelection(item,itemToElementMap){
if(this._preventAutoScroll===!0||
this._isScrolling===!0||
_.exists(this._lastItem)&&this._lastItem===item){
return;
}

const itemButtonElement=itemToElementMap.get(item);
if(!_.exists(itemButtonElement)){
this._lastItem=void 0;
return;
}

fastdom.mutate(()=>{
try{
const newScrollTop=_tryGetNewScrollTop(itemButtonElement,this._scrollerWrapper);
if(!_.exists(newScrollTop)){
return;
}
if(this._lastPosition===newScrollTop){
return;
}

this._lastItem=item;
this._isScrolling=!0;
this._scrollerWrapper.animate({scrollTop:newScrollTop},ScrollDurationMs);
this._lastPosition=newScrollTop;
}catch(err){
console.error(err);
}finally{
this._isScrolling=!1;
}
});
}};


const _getTopAndInnerHeightFor=element=>{
return{
top:element.offset().top,
innerHeight:element.innerHeight()};

};


function _tryGetNewScrollTop(element,scrollerWrapper){
let elementInfo;
if(!element.is(':visible')){
element.css({visibility:'hidden'}).show();
elementInfo=_getTopAndInnerHeightFor(element);
element.css({visibility:'',display:''});
}else{
elementInfo=_getTopAndInnerHeightFor(element);
}

const visibleAreaStart=scrollerWrapper.scrollTop();
const visibleAreaEnd=visibleAreaStart+scrollerWrapper.innerHeight();
const innerScrollerVerticalOffset=scrollerWrapper.find('> .scrollable-content').offset().top;

const elementDistanceFromTopOfScrollableArea=elementInfo.top-innerScrollerVerticalOffset;

const startsBeforeVisibleArea=elementDistanceFromTopOfScrollableArea<visibleAreaStart;
const endsAfterVisibleArea=elementDistanceFromTopOfScrollableArea+elementInfo.innerHeight>visibleAreaEnd;

if(!startsBeforeVisibleArea&&!endsAfterVisibleArea){
return;
}

const scrollTop=startsBeforeVisibleArea?
Math.max(elementDistanceFromTopOfScrollableArea-elementInfo.innerHeight*0.5,0):
visibleAreaStart+(elementDistanceFromTopOfScrollableArea+elementInfo.innerHeight-visibleAreaEnd)+elementInfo.innerHeight*0.55;

if(scrollTop===visibleAreaStart){
return;
}

return scrollTop;
}

module.exports=SidebarScrollingService;
//# sourceMappingURL=sidebarScrollingService.js.map
